module.exports = __webpack_public_path__ + "img/4f_r_gindako@2x.59ac8dca.png";